import { useContext, useEffect, useRef } from "react";
import { UserInfoStatusContext } from "../../components/UserInfo";

export interface SubjectStatusBridgeProps {
  subjectUserId?: string;
  /** Announced once, after the selection change the write caused. */
  pendingMessage?: string;
  /** Must be stable. */
  onAnnounced: () => void;
}

/**
 * Lets the shell reach the live region it renders. Clears the region when the subject changes, then
 * announces `pendingMessage`, so a create or delete outcome survives its own selection change.
 */
export const SubjectStatusBridge = ({
  subjectUserId,
  pendingMessage,
  onAnnounced
}: SubjectStatusBridgeProps) => {
  const announce = useContext(UserInfoStatusContext);
  const previousSubjectRef = useRef(subjectUserId);

  useEffect(() => {
    if (previousSubjectRef.current !== subjectUserId) {
      previousSubjectRef.current = subjectUserId;
      announce("");
    }

    if (pendingMessage) {
      announce(pendingMessage);
      onAnnounced();
    }
  }, [announce, onAnnounced, pendingMessage, subjectUserId]);

  return null;
};
